export const mailProAPIConstants = {
  APPROVE_MAILPRO_AREA_API: "/agent/approveAreaIDForBCCForListgenUser",
};

const mailPropSuffix = "MAILPRO_";
export const mailProActionConstants = {
  APPROVE_MAILPRO_AREA: mailPropSuffix + "APPROVE_MAILPRO_AREA",
};
